<div class="content">
    <p>Can't create new vendor!</p>
    <h3>
        Vendor name is already taken, Please change vendor name.
    </h3>
    <button mat-raised-button class="button" (click)="onNoClick()">Ok</button>
</div>